import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useGetProductsQuery } from "../slices/productsApiSlice";
import { useGetCategoriesQuery } from "../slices/categoriesApiSlice";
import { Link } from "react-router-dom";
import Product from "../components/Product";
import Loader from "../components/Loader";
import Message from "../components/Message";
import Paginate from "../components/Paginate";
import ProductCarousel from "../components/ProductCarousel";
import Meta from "../components/Meta";
import Statement from "../components/Statement";
// import Testimonials from "../components/Testimonials";
import ContactUs from "../components/ContactUs";
import { Helmet } from 'react-helmet-async';


const HomeScreen = () => {
  const { pageNumber, keyword } = useParams();

  const [selectedCategory, setSelectedCategory] = useState('');
  const [categoryPage, setCategoryPage] = useState(1);

  const { data: categories } = useGetCategoriesQuery();

  const { data, isLoading, error } = useGetProductsQuery({
    keyword,
    pageNumber: selectedCategory ? categoryPage : pageNumber,
    category: selectedCategory,
  });


    const structuredData = {
    "@context": "https://schema.org",
    "@type": "Store",
    "name": "חושבים פלוס",
    "description": "משחקי חשיבה ואסטרטגיה לילדים",
    "url": "https://www.hoshvim-plus.com",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IL"
    }
  };

  return (
    <>
      <Meta
        title="חושבים פלוס - משחקי חשיבה ואסטרטגיה לילדים"
        description="חושבים פלוס - החנות המובילה למשחקי חשיבה ואסטרטגיה לילדים. קנו משחקים איכותיים עם משלוח מהיר לכל הארץ"
        keywords="חושבים פלוס, משחקים לילדים, משחקי חשיבה, אסטרטגיה, גיבוש"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {!keyword ? (
        <ProductCarousel />
      ) : (
        <Link to="/" className="btn btn-light mb-4">
          Go Back
        </Link>
      )}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <>
          {/* Category filter */}
          {!keyword && categories && categories.length > 0 && (
            <div className="d-flex justify-content-center flex-wrap gap-2 mb-4 mt-5" dir="rtl">
              <button
                onClick={() => { setSelectedCategory(''); setCategoryPage(1); }}
                style={{
                  border: selectedCategory === '' ? 'none' : '1px solid #ccc',
                  backgroundColor: selectedCategory === '' ? '#6B46C1' : '#f8f9fa',
                  color: selectedCategory === '' ? '#fff' : '#555',
                  borderRadius: '25px',
                  padding: '8px 22px',
                  cursor: 'pointer',
                  fontWeight: selectedCategory === '' ? '600' : '400',
                  fontSize: '0.95rem',
                  transition: 'all 0.2s',
                  boxShadow: selectedCategory === '' ? '0 2px 8px rgba(107,70,193,0.35)' : 'none',
                }}
              >
                כל המוצרים
              </button>
              {categories.map((cat) => (
                <button
                  key={cat._id}
                  onClick={() => { setSelectedCategory(cat._id); setCategoryPage(1); }}
                  style={{
                    border: selectedCategory === cat._id ? 'none' : '1px solid #ccc',
                    backgroundColor: selectedCategory === cat._id ? '#6B46C1' : '#f8f9fa',
                    color: selectedCategory === cat._id ? '#fff' : '#555',
                    borderRadius: '25px',
                    padding: '8px 22px',
                    cursor: 'pointer',
                    fontWeight: selectedCategory === cat._id ? '600' : '400',
                    fontSize: '0.95rem',
                    transition: 'all 0.2s',
                    boxShadow: selectedCategory === cat._id ? '0 2px 8px rgba(107,70,193,0.35)' : 'none',
                  }}
                >
                  {cat.name}
                </button>
              ))}
            </div>
          )}

          <Row className="g-2 mb-5">
            {data.products.map((product) => (
              <Col key={product._id} xs={6} md={6} lg={4} xl={3}>
                <Product product={product} />
              </Col>
            ))}
          </Row>
          <Paginate
            pages={data.pages}
            page={data.page}
            keyword={keyword ? keyword : ""}
            onPageChange={selectedCategory ? (p) => { setCategoryPage(p); window.scrollTo({ top: 0, behavior: 'smooth' }); } : undefined}
          />
        </>
      )}
      <Statement />
      {/* <Testimonials /> */}
      <ContactUs />
    </>
  );
};
export default HomeScreen;
